import Image from "next/image"

interface DuotoneProps {
  src: string
  alt: string
  sizes?: string
  priority?: boolean
  className?: string
}

/* Editorial imagery recolored to the active PaletteScope: shadows take
   --palette-accent, highlights take --palette-tint, so one photo reads as a
   different color world per section. The treatment is decorative recoloring —
   keep `alt` describing the photo's actual content. The parent gives this its
   size (an aspect box or a filled cover); next/image fills it. */
export const Duotone = ({ src, alt, sizes = "100vw", priority = false, className }: DuotoneProps) => (
  <div className={`duotone size-full ${className ?? ""}`}>
    <Image src={src} alt={alt} fill sizes={sizes} priority={priority} className="object-cover" />
  </div>
)
